import { IStore } from '../types';

export const initialStore: IStore = {
    genres: [],
};
